import { Button, Header, Paragraph, StarOutlineIcon } from "@datagame/ui";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import FeatureNotSupportedImage from "../../../../assets/images/FeatureNotSupported.svg";

import styles from "./FeatureNotSupported.module.scss";

export const FeatureNotSupported = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const redirectToSubscriptionPage = () => {
    navigate("/subscription");
  };

  return (
    <div className={styles.section}>
      <div className={styles.headerContent}>
        <Header variant="h5">{t("company:usersSection.title")}</Header>
        <Paragraph size="small">{t("company:usersSection.description")}</Paragraph>
      </div>
      <div className={styles.notSupportedWrapper}>
        <img src={FeatureNotSupportedImage} alt="Feature not supported" />
        <div className={styles.notSupportedText}>
          <Paragraph color="secondary" size="large" weight="font-bold">
            {t("company:disabledTitle")}
          </Paragraph>
          <Paragraph className={styles.description}>{t("company:disabledDescription")}</Paragraph>
        </div>
        <Button icon={<StarOutlineIcon />} iconSide="left" kind="outline" onClick={redirectToSubscriptionPage}>
          {t("company:subscriptionPlan")}
        </Button>
      </div>
    </div>
  );
};
